import useQuery from "@/hooks/useQuery"

type UseQueryFilterResponse = {
	getChatPhoneSearch: () => {
		phoneSearch: string | null
		isValidPhoneSearch: boolean
	}
	getChatClientIdSearch: () => {
		clientId: string | null
	}
	query: URLSearchParams
	getQueryParamSearch: (queryParamKey: UseQueryFilterOptions) => string | null
}

type UseQueryFilterOptions = "phone" | "clientId" | "nickname" | "webhooktemplate"

const useQueryFilters = (): UseQueryFilterResponse => {
	const query = useQuery()

	const getQueryParamSearch = (queryParamKey: UseQueryFilterOptions): string | null => {
		const searchValue = query.get(queryParamKey)

		if (!searchValue) {
			return null
		}

		query.delete(queryParamKey)

		return searchValue
	}

	const getChatPhoneSearch = (): {
		phoneSearch: string | null
		isValidPhoneSearch: boolean
	} => {
		const phoneSearch = getQueryParamSearch("phone")

		const isValidPhoneSearch = !isNaN(Number(phoneSearch))

		return {
			phoneSearch,
			isValidPhoneSearch
		}
	}

	const getChatClientIdSearch = (): {
		clientId: string | null
	} => {
		const clientId = getQueryParamSearch("clientId")

		return {
			clientId
		}
	}

	return {
		getChatPhoneSearch,
		getChatClientIdSearch,
		query,
		getQueryParamSearch
	}
}

export default useQueryFilters
